import React from 'react';
import styled from 'styled-components';
import SanityImage from 'gatsby-plugin-sanity-image';
import PropTypes from 'prop-types';
import breakpoints from '../../breakpoints';
import sharedStyles from '../../styles';

const CardsContainer = styled.div`
  display: flex;
  gap: ${sharedStyles.spacing['spacing-md']};
  flex-direction: column;
  margin-block: ${sharedStyles.spacing['spacing-1xl']};

  @media (min-width: ${breakpoints.md}) {
    gap: 1.25rem;
    flex-direction: row;
  }
`;

const Card = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  padding-bottom: ${sharedStyles.spacing['spacing-md']};
  background: ${({ theme }) => theme.colors.cardBackground};
`;

const CardText = styled.h2`
  margin: 0;
  padding: 1.25rem 0.5rem;
  text-align: center;
  text-transform: uppercase;
  font-size: 1.25rem;
  flex: 1;
`;

const ImageContainer = styled.div`
  aspect-ratio: 3/2;
  overflow: hidden;
  width: 100%;
`;

function CallToActionRow({ value: { items }, getInternalLink, Button }) {
  return (
    items?.length && (
      <CardsContainer>
        {items?.map(item => (
          // eslint-disable-next-line no-underscore-dangle
          <Card key={item?._key}>
            {item?.media?.asset && (
              <ImageContainer>
                <SanityImage
                  asset={item.media?.asset}
                  hotspot={item.media?.hotspot}
                  alt={item.media?.alt || item.heading}
                  width={400}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </ImageContainer>
            )}
            <CardText>{item.heading}</CardText>

            {item.link?.linkType === 'internal' && (
              <Button
                to={getInternalLink({
                  ...item.link,
                  reference: item.link?.internalLink,
                })}
              >
                {item.actionText}
              </Button>
            )}
            {item.link?.linkType === 'external' && (
              <Button href={item.link.href}>{item.actionText}</Button>
            )}
          </Card>
        ))}
      </CardsContainer>
    )
  );
}

CallToActionRow.propTypes = {
  value: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        media: PropTypes.shape({
          asset: PropTypes.shape({
            url: PropTypes.string,
          }),
          hotspot: PropTypes.shape({}),
        }),
      })
    ),
    heading: PropTypes.string,
  }).isRequired,
  getInternalLink: PropTypes.func.isRequired,
  Button: PropTypes.func.isRequired,
};

export default CallToActionRow;
